exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Label */\n.uu5-forms-label {\n  color: #8b8b8b;\n  padding-top: .5em;\n  padding-bottom: .5em;\n  margin-bottom: 0;\n  text-align: left;\n}\n.uu5-common-disabled .uu5-forms-label {\n  position: relative !important;\n  cursor: not-allowed !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/internal/label.less
// module id = 323
// module chunks = 0